import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Heading = styled.h2`
  ${props => props.theme.typography.heading2}
  margin-top: ${({ theme }) => theme.spacing(8)};
  text-align: center;
`;

const Text = styled.p`
  ${props => props.theme.typography.body}
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(6)};
`;

export const Slide = ({ img, imgAlt, heading, text }) => (
  <SlideWrapper>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    {img && <img src={img} alt={imgAlt} height={100} />}
    {heading && <Heading>{heading}</Heading>}
    {text && <Text>{text}</Text>}
  </SlideWrapper>
);

Slide.displayName = 'Slide';

Slide.propTypes = {
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  heading: PropTypes.string,
  text: PropTypes.string,
};
